import { message } from 'antd';
import { MessageInstance } from 'antd/lib/message';

export const messageAtom: MessageInstance = message;
